/* ============================================================
   PCHEEBUM — Shopify Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  // ── Header: static, always cream (no scroll behavior) ───
  function initHeader() {
    // Header is position:relative and always shows cream background.
    // Nothing to initialize — no scroll listener needed.
  }

  // ── Hero Carousel ─────────────────────────────────────────
  function initHeroCarousel() {
    const carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.hero-slide');
    const dots = carousel.querySelectorAll('.hero-dot');
    const prevBtn = carousel.querySelector('.hero-arrow--prev');
    const nextBtn = carousel.querySelector('.hero-arrow--next');
    const progressBar = carousel.querySelector('.hero-carousel__progress-bar');

    if (!slides.length) return;

    let current = 0;
    let autoplayTimer = null;
    let progressTimer = null;
    let progressStart = null;
    const AUTOPLAY_MS = 6000;
    const TYPEWRITER_SPEED = 45;

    function getSlide(i) { return slides[i]; }

    // Typewriter effect
    function typewriter(el, html, onDone) {
      const steps = [];
      let i = 0;
      while (i < html.length) {
        if (html[i] === '<') {
          const end = html.indexOf('>', i);
          i = (end !== -1) ? end + 1 : i + 1;
        } else {
          i++;
        }
        steps.push(html.substring(0, i));
      }

      let step = 0;
      el.innerHTML = '';

      const cursor = document.createElement('span');
      cursor.className = 'typing-cursor';
      cursor.textContent = '|';

      function tick() {
        if (step < steps.length) {
          el.innerHTML = steps[step];
          el.appendChild(cursor);
          step++;
          setTimeout(tick, TYPEWRITER_SPEED);
        } else {
          setTimeout(() => {
            cursor.style.transition = 'opacity 0.3s ease';
            cursor.style.opacity = '0';
            setTimeout(() => { cursor.remove(); if (onDone) onDone(); }, 300);
          }, 900);
          if (onDone) setTimeout(onDone, 200);
        }
      }
      tick();
    }

    function showSlideContent(slide) {
      const eyebrow = slide.querySelector('.hero-slide__eyebrow');
      const headlineEl = slide.querySelector('.hero-slide__headline');
      const sub = slide.querySelector('.hero-slide__sub');
      const ctas = slide.querySelector('.hero-slide__ctas');
      const headlineHTML = headlineEl ? headlineEl.getAttribute('data-headline') : '';

      if (eyebrow) {
        setTimeout(() => eyebrow.classList.add('is-visible'), 100);
      }

      if (headlineEl && headlineHTML) {
        headlineEl.innerHTML = '';
        setTimeout(() => {
          typewriter(headlineEl, headlineHTML, () => {
            if (sub) sub.classList.add('is-visible');
          });
        }, 300);
        // Show the CTA in parallel with the typewriter (≈300ms in) instead of
        // waiting for the full typewriter completion (~2.5s). Customers should
        // be able to tap "SHOP BEST SELLERS" immediately on landing.
        if (ctas) setTimeout(() => ctas.classList.add('is-visible'), 350);
      } else {
        if (sub) setTimeout(() => sub.classList.add('is-visible'), 500);
        if (ctas) setTimeout(() => ctas.classList.add('is-visible'), 350);
      }
    }

    function hideSlideContent(slide) {
      const els = slide.querySelectorAll('.hero-slide__eyebrow, .hero-slide__sub, .hero-slide__ctas');
      els.forEach(el => el.classList.remove('is-visible'));
    }

    function goTo(next) {
      if (next === current) return;
      const prevSlide = getSlide(current);
      const nextSlide = getSlide(next);

      hideSlideContent(prevSlide);
      prevSlide.classList.remove('is-active');
      prevSlide.classList.add('is-prev');

      current = next;
      nextSlide.classList.add('is-active');
      nextSlide.classList.remove('is-prev');

      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));

      setTimeout(() => {
        prevSlide.classList.remove('is-prev');
        showSlideContent(nextSlide);
      }, 400);

      resetAutoplay();
    }

    function startProgress() {
      if (progressBar) {
        progressStart = Date.now();
        progressBar.style.width = '0%';
        progressTimer = setInterval(() => {
          const elapsed = Date.now() - progressStart;
          const pct = Math.min((elapsed / AUTOPLAY_MS) * 100, 100);
          progressBar.style.width = pct + '%';
        }, 50);
      }
    }

    function stopProgress() {
      if (progressTimer) { clearInterval(progressTimer); progressTimer = null; }
      if (progressBar) progressBar.style.width = '0%';
    }

    function resetAutoplay() {
      stopProgress();
      if (autoplayTimer) clearTimeout(autoplayTimer);
      startProgress();
      autoplayTimer = setTimeout(() => {
        goTo((current + 1) % slides.length);
      }, AUTOPLAY_MS);
    }

    // Init first slide
    getSlide(0).classList.add('is-active');
    dots[0]?.classList.add('is-active');
    showSlideContent(getSlide(0));
    resetAutoplay();

    // Dot clicks
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // Arrow clicks
    if (prevBtn) prevBtn.addEventListener('click', () => goTo((current - 1 + slides.length) % slides.length));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo((current + 1) % slides.length));

    // Pause on hover
    carousel.addEventListener('mouseenter', () => { if (autoplayTimer) clearTimeout(autoplayTimer); stopProgress(); });
    carousel.addEventListener('mouseleave', resetAutoplay);

    // Touch swipe
    let touchStartX = 0;
    carousel.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0
          ? (current + 1) % slides.length
          : (current - 1 + slides.length) % slides.length
        );
      }
    }, { passive: true });
  }

  // ── Mobile Menu ───────────────────────────────────────────
  function initMobileMenu() {
    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const closeBtn = document.getElementById('mobile-menu-close');
    if (!hamburger || !mobileMenu) return;

    function toggle(open) {
      mobileMenu.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      hamburger.setAttribute('aria-expanded', open);
    }

    hamburger.addEventListener('click', () => toggle(!mobileMenu.classList.contains('is-open')));
    closeBtn?.addEventListener('click', () => toggle(false));
    // Close on Escape key — accessibility / standard modal behavior
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) toggle(false);
    });
  }

  // ── Cart Drawer ───────────────────────────────────────────
  function initCartDrawer() {
    // Always query fresh — never cache overlay/drawer references
    function getOverlay() { return document.querySelector('.cart-overlay'); }
    function getDrawer()  { return document.querySelector('.cart-drawer'); }
    function getDrawerSection() {
      return document.getElementById('shopify-section-cart-drawer')
        || getDrawer()?.parentElement;
    }

    function bindDrawerEvents() {
      // Use replaceWith trick to remove old listeners before adding new ones
      var closeBtn = getDrawer()?.querySelector('.cart-drawer__close');
      if (closeBtn) {
        var newBtn = closeBtn.cloneNode(true);
        closeBtn.parentNode?.replaceChild(newBtn, closeBtn);
        newBtn.addEventListener('click', closeCart);
      }
      // Overlay: remove old listener by replacing the element reference approach
      // Use a named handler stored on the element to avoid stacking
      var overlay = getOverlay();
      if (overlay && !overlay._closeHandlerBound) {
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) closeCart();
        });
        overlay._closeHandlerBound = true;
      }
    }

    function openCart() {
      getOverlay()?.classList.add('is-open');
      getDrawer()?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeCart() {
      getOverlay()?.classList.remove('is-open');
      getDrawer()?.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Re-render drawer — keep it visually open if it already was
    async function refreshCartDrawer() {
      const wasOpen = getDrawer()?.classList.contains('is-open');
      try {
        const res = await fetch('/?sections=cart-drawer');
        if (!res.ok) return;
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const wrap = getDrawerSection();
        if (wrap) {
          wrap.innerHTML = html;
          // Immediately restore open state so drawer doesn't disappear
          if (wasOpen) {
            getDrawer()?.classList.add('is-open');
            getOverlay()?.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          }
          bindDrawerEvents();
          if (typeof window.initCartDrawerV2 === 'function') window.initCartDrawerV2();
        }
      } catch(e) { /* fallback: open stale content */ }
    }

    document.querySelectorAll('[data-open-cart]').forEach(btn =>
      btn.addEventListener('click', openCart)
    );
    bindDrawerEvents();

    // Close drawer on Escape key — accessibility / standard modal behavior.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && getDrawer()?.classList.contains('is-open')) closeCart();
    });

    window.pcheebumCart = {
      open: openCart,
      close: closeCart,
      refresh: refreshCartDrawer,
      refreshAndOpen: async function() {
        await refreshCartDrawer();
        openCart();
      }
    };
  }

  // ── Scroll Reveal ─────────────────────────────────────────
  function initScrollReveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length || !window.IntersectionObserver) {
      els.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => obs.observe(el));
  }

  // ── Product Gallery (PDP) ─────────────────────────────────
  function initPDPGallery() {
    const thumbs = document.querySelectorAll('.pdp__thumb');
    const mainImg = document.querySelector('.pdp__gallery-main img');
    const main = document.querySelector('.pdp__gallery-main');
    if (!mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.getAttribute('data-src');
        if (src) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
        }
      });
    });

    // Swipe-to-cycle on mobile (where thumbs are hidden) — without this
    // shoppers see only image #1 and never the back / side / detail photos.
    if (main && thumbs.length > 1) {
      const sources = Array.from(thumbs).map(t => t.getAttribute('data-src')).filter(Boolean);
      let index = 0;

      // Inject swipe-position dots so customers know there's more.
      const dots = document.createElement('div');
      dots.className = 'pdp__gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      sources.forEach((_, i) => {
        const d = document.createElement('span');
        d.className = 'pdp__gallery-dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(d);
      });
      main.appendChild(dots);
      const dotEls = dots.querySelectorAll('.pdp__gallery-dot');

      let touchStartX = 0;
      let touchStartY = 0;
      function setIndex(i) {
        index = (i + sources.length) % sources.length;
        mainImg.style.opacity = '0.85';
        setTimeout(() => {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = sources[index];
          thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === index));
          dotEls.forEach((d, idx) => d.classList.toggle('is-active', idx === index));
          mainImg.style.opacity = '1';
        }, 80);
      }
      main.addEventListener('touchstart', e => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        // Horizontal swipe only — ignore vertical scrolls
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          setIndex(index + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
      // Keep index in sync if user clicks a thumb on desktop
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        index = i;
        dotEls.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      }));
    }
  }

  // ── Size Selector ─────────────────────────────────────────
  function initSizeSelector() {
    const btns = document.querySelectorAll('.size-btn');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
      });
    });
  }

  // ── Color Swatches ────────────────────────────────────────
  function initColorSwatches() {
    const swatches = document.querySelectorAll('.color-swatch');
    swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        swatches.forEach(s => s.classList.remove('is-selected'));
        swatch.classList.add('is-selected');
      });
    });
  }

  // ── Email Forms ───────────────────────────────────────────
  function initEmailForms() {
    document.querySelectorAll('.js-email-form').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('input[type="email"]');
        const btn = form.querySelector('button[type="submit"]');
        if (!input?.value) return;

        const originalText = btn?.textContent;
        if (btn) btn.textContent = 'Joining...';

        // Shopify customer subscribe endpoint
        try {
          await fetch('/contact#contact_form', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ 'contact[email]': input.value, form_type: 'customer' })
          });
          input.value = '';
          if (btn) { btn.textContent = '✓ You\'re in!'; }
          setTimeout(() => { if (btn) btn.textContent = originalText; }, 3000);
        } catch {
          if (btn) btn.textContent = originalText;
        }
      });
    });
  }

  // ── Sticky ATC on PDP ─────────────────────────────────────
  function initStickyATC() {
    const atcBtn = document.querySelector('.pdp__atc');
    if (!atcBtn) return;

    const stickyBar = document.querySelector('.pdp-sticky-bar');
    if (!stickyBar) return;

    const obs = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    obs.observe(atcBtn);
  }

  // ── Add to Cart ───────────────────────────────────────────
  function initAddToCart() {
    async function handleAddToCart(btn, variantId) {
      if (!variantId) return;
      const original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = '✓ Added!';
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          // Update cart-count badges only — never the wishlist badge (also class .cart-badge).
          document.querySelectorAll('.cart-badge:not(.wishlist-count)').forEach(badge => {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
          await window.pcheebumCart?.refreshAndOpen();
        } else {
          btn.textContent = 'Error – Try Again';
        }
      } catch(err) {
        btn.textContent = 'Error – Try Again';
      } finally {
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2500);
      }
    }

    // Standalone .js-atc buttons NOT inside a product form (cart drawer upsells,
    // quick-add tiles, recommendation rails). The PDP product-form has its own
    // submit handler inline in product-main.liquid — binding here would duplicate
    // the /cart/add.js call and add 2× per click.
    document.querySelectorAll('.js-atc').forEach(btn => {
      if (btn.closest('form[action*="/cart/add"], form#product-form')) return;
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.getAttribute('data-variant-id');
        await handleAddToCart(btn, variantId);
      });
    });
  }

  // ── Init All ──────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initHeroCarousel();
    initMobileMenu();
    initCartDrawer();
    initScrollReveal();
    initPDPGallery();
    initSizeSelector();
    initColorSwatches();
    initEmailForms();
    initStickyATC();
    initAddToCart();
  });

})();

/* ── Search Overlay + Predictive Search ─────────────────────── */
(function() {
  const overlay      = document.getElementById('search-overlay');
  const backdrop     = overlay?.querySelector('.search-overlay__backdrop');
  const input        = document.getElementById('search-overlay-input');
  const closeBtn     = document.getElementById('search-close-btn');
  const clearBtn     = document.getElementById('search-clear-btn');
  const spinner      = document.getElementById('search-spinner');
  const popularEl    = document.getElementById('search-popular');
  const predictiveEl = document.getElementById('search-predictive-results');
  const listEl       = document.getElementById('search-predictive-list');
  const viewAllEl    = document.getElementById('search-view-all');

  if (!overlay) return;

  /* ── Open / Close ── */
  function openSearch() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input?.focus(), 80);
    // Reset to popular state if input is empty
    if (!input?.value.trim()) showPopular();
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    clearPredictive();
  }

  // Wire all Search buttons
  document.querySelectorAll('[aria-label="Search"]').forEach(btn => {
    if (btn.tagName === 'BUTTON') btn.addEventListener('click', openSearch);
  });
  window.__openSearch = openSearch;

  backdrop?.addEventListener('click', closeSearch);
  closeBtn?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });

  /* ── Clear button ── */
  input?.addEventListener('input', () => {
    const hasVal = input.value.trim().length > 0;
    if (clearBtn) clearBtn.style.display = hasVal ? 'flex' : 'none';
    if (!hasVal) {
      clearPredictive();
      showPopular();
    }
  });
  clearBtn?.addEventListener('click', () => {
    if (input) { input.value = ''; input.focus(); }
    if (clearBtn) clearBtn.style.display = 'none';
    clearPredictive();
    showPopular();
  });

  /* ── State helpers ── */
  function showPopular() {
    if (popularEl)    popularEl.style.display    = '';
    if (predictiveEl) predictiveEl.style.display = 'none';
  }

  function showPredictive() {
    if (popularEl)    popularEl.style.display    = 'none';
    if (predictiveEl) predictiveEl.style.display = '';
  }

  function clearPredictive() {
    if (listEl)    listEl.innerHTML = '';
    if (viewAllEl) viewAllEl.style.display = 'none';
    showPopular();
  }

  /* ── Format money ── */
  /* Handles Shopify price_min as integer cents (2500 → $25) OR decimal string ("25.00" → $25) */
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    const num = parseFloat(cents);
    if (isNaN(num)) return '';
    const isAlreadyDollars = typeof cents === 'string' && String(cents).indexOf('.') !== -1;
    const dollars = isAlreadyDollars ? num : num / 100;
    return '$' + dollars.toFixed(2).replace(/\.00$/, '');
  }

  /* ── Render one product row ── */
  function renderItem(product) {
    const li = document.createElement('li');
    /* 160×200 portrait crop (was 120×120 square) — clothing photos read better
       in portrait, and the predictive thumb is now 64×80 in CSS. */
    const imgSrc = product.featured_image?.url
      ? product.featured_image.url.replace(/\.[^.]+$/, m => '_160x200' + m)
      : null;

    /* Use Shopify's pre-formatted price string if available; fall back to price_min */
    const price = product.price != null ? product.price : (product.price_min != null ? formatMoney(product.price_min) : '');
    const category = product.product_type || '';

    li.innerHTML = `
      <a href="${product.url}" class="search-predictive__item" role="option">
        ${imgSrc
          ? `<img src="${imgSrc}" alt="${product.title}" class="search-predictive__thumb" loading="lazy" width="64" height="80">`
          : `<div class="search-predictive__thumb-placeholder"></div>`
        }
        <span class="search-predictive__info">
          <span class="search-predictive__name">${product.title}</span>
          ${category ? `<span class="search-predictive__type">${category}</span>` : ''}
        </span>
        ${price ? `<span class="search-predictive__price">${price}</span>` : ''}
      </a>`;
    return li;
  }

  /* ── Debounced fetch from Shopify Predictive Search API ── */
  let debounceTimer = null;
  let currentQuery  = '';

  function fetchPredictive(query) {
    currentQuery = query;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      if (!query || query !== currentQuery) return;

      // Show spinner
      if (spinner) spinner.style.display = 'block';

      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const res  = await fetch(url);
        if (!res.ok) throw new Error('Fetch failed');
        const data = await res.json();

        // Guard stale responses
        if (query !== currentQuery) return;

        const products = data?.resources?.results?.products || [];

        if (spinner) spinner.style.display = 'none';

        if (products.length === 0) {
          listEl.innerHTML = `<li class="search-predictive__empty">No products found for &ldquo;${query}&rdquo;</li>`;
          if (viewAllEl) viewAllEl.style.display = 'none';
          showPredictive();
          return;
        }

        listEl.innerHTML = '';
        products.forEach(p => listEl.appendChild(renderItem(p)));

        // View all link
        if (viewAllEl) {
          viewAllEl.href = `/search?type=product&q=${encodeURIComponent(query)}`;
          viewAllEl.style.display = '';
        }

        showPredictive();

      } catch (err) {
        if (spinner) spinner.style.display = 'none';
        console.warn('[Pcheebum] Predictive search error:', err);
      }
    }, 220); // 220ms debounce — fast but avoids hammering on every keystroke
  }

  /* ── Wire input to predictive fetch ── */
  input?.addEventListener('input', () => {
    const q = input.value.trim();
    if (q.length >= 2) {
      fetchPredictive(q);
    } else if (q.length === 0) {
      if (spinner) spinner.style.display = 'none';
    }
  });

  // Keyboard: Enter still submits the form; arrows could navigate list (future)
  input?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') return; // let the form submit naturally
  });
})();